import React from 'react'
import Header from './Components/Header';
import AboutUsComp from './Components/AboutUsComp';
import PrincipalBroker from './Components/PrincipalBroker';
import Footer from './Components/Footer';


function AboutUs() {

    return (
        <div>
            <Header />
            <AboutUsComp />
            <PrincipalBroker />
            <Footer />
        </div>
    )
}

export default AboutUs
